/*******************************************************************************
OPEN CONFIRMATION MODAL WINDOW
Opens a confirmation modal window
*******************************************************************************/

import buildItemEditModal from './build-modal-item-editor';

export default function openItemEditorModal(e) {

    // Get any confirmation modal settings that exist on the button that triggered the modal
    const $triggerButton = $(e.currentTarget);
    const options = {
        title            : $triggerButton.data('title'),
        itemID           : $triggerButton.data('id'),
        itemName         : $triggerButton.data('item-name'),
        itemValue        : $triggerButton.data('item-value'),
        maxlength        : $triggerButton.data('maxlength'),
        cancelButton     : $triggerButton.data('cancel-button'),
        saveButton       : $triggerButton.data('save-button'),
        saveClass        : $triggerButton.data('save-class'),
        includeBackground: $triggerButton.data('include-bg'),
    };

    // Build the rename watchlist editor modal window
    const modalHTML = buildItemEditModal(options);

    // Add the modal window to the page
    $('.page').after(modalHTML);
}
